import { render } from "./SpendingSummary.vue?vue&type=template&id=186dfaf4&ts=true"
import script from "./SpendingSummary.vue?vue&type=script&lang=ts"
export * from "./SpendingSummary.vue?vue&type=script&lang=ts"

import "./SpendingSummary.vue?vue&type=style&index=0&id=186dfaf4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__